'use client'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'
import { Navigation, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useState } from 'react'
import { SvgArrowLeft, SvgArrowRightWhite } from '../icons'
import './carousel.css'

export default function SwiperCarousel() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)

  const data = [
    {
      icon: '/VoxMind.svg',
      img: '/VoxMindBg.webp',
      title: 'VoxMind',
      content: 'Your Voice, Your Identity - Instantly recognised',
      href: 'https://www.aiforge.org/investors/1237fc71-ce80-4737-b923-020e9acfdfe1/overview',
    },
    {
      icon: '/Donaa.svg',
      img: '/DonaaBg.webp',
      title: 'Donaa',
      content: 'The first AI fault detection system for 3D Printers',
      href: 'https://www.aiforge.org/investors/6e9d7fcf-612b-4a67-abaa-fd8e317df5e9/overview',
    },
    {
      icon: '/Route.svg',
      img: '/RouteBg.webp',
      title: 'Route',
      content: 'AI-Driven Mobile Workforce Optimisation in Real-Time.',
      href: 'https://www.aiforge.org/investors/be348fb0-f2ab-4dbf-9799-be47a858b324/overview',
    },
  ]

  return (
    <>
      <div className="pt-16 relative">
        <div className="flex overflow-hidden">
          <Swiper
            onSwiper={setThumbsSwiper}
            loop={true}
            modules={[Navigation, Thumbs]}
            slidesPerView={data.length}
            direction={'vertical'}
            className={'swiperMenu w-1/5'}
          >
            {data.map((content, idx) => {
              return (
                <SwiperSlide
                  key={'thumb_' + idx}
                  className={idx == 0 ? '' : ''}
                >
                  <div className=" cursor-pointer self-stretch h-[62px] pl-6 pr-4 py-4 flex-col justify-start items-start gap-5 flex">
                    <div className="self-stretch h-[30px] flex-col justify-start items-center gap-2 flex">
                      <div className="self-stretch text-white text-xl font-semibold leading-[30px]">
                        {content.title}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>

          <div className="w-full lg:w-4/5">
            <Swiper
              className={'swiperCarousel'}
              navigation={{
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
                disabledClass: 'hidden',
              }}
              loop={true}
              thumbs={{
                swiper:
                  thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
              }}
              modules={[Navigation, Thumbs]}
              spaceBetween={10}
            >
              {data?.map((item, index) => (
                <SwiperSlide key={'slide_' + index}>
                  <div className="relative sm:h-[500px] lg:h-[613px] flex border border-[#D6D6D6] overflow-hidden justify-end rounded-2xl h-full w-full">
                    <img
                      src={item.img}
                      className="absolute top-0 left-0 object-cover w-full h-full "
                      alt=""
                    />

                    <div className="relative  w-full p-3 md:p-6  lg:p-12 bg-gradient-to-b from-black/0 to-black justify-end sm:justify-between items-start sm:items-end inline-flex flex-col sm:flex-row lg:h-[613px]">
                      <div className="max-w-3xl flex-col justify-start items-start gap-2.5 inline-flex w-full sm:w-[260px] md:w-full">
                        <div className="flex items-center gap-2 md:gap-3 w-full md:h-full">
                          <img
                            src={item.icon}
                            className="object-cover "
                            alt=""
                          />
                        </div>

                        <div></div>
                        <p className="text-white text-xl sm:text-3xl md:text-4xl lg:text-4xl font-bold lg:leading-[60px]">
                          {item.content ===
                          'Your Voice, Your Identity - Instantly recognised' ? (
                            <span>
                              Your Voice, Your Identity - <br></br> Instantly
                              recognised{' '}
                            </span>
                          ) : (
                            item.content
                          )}
                        </p>
                      </div>
                      <a
                        href={item?.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Read more"
                      >
                        <SvgArrowRightWhite className="w-8 h-8  shrink-0" />
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div className="flex lg:flex-col items-center max-lg:gap-6 lg:mx-auto w-fit mt-6 sm:mt-10 lg:mt-0 lg:absolute top-16 right-0  z-30">
          <button
            aria-label="arrow right"
            className="!block lg:py-5 lg:px-7 swiper-prev lg:rounded-tr-xl bg-neutral-200 lg:h-[82px] lg:w-[93.71px] "
          >
            <SvgArrowLeft className="text-black" />
          </button>

          <button
            aria-label="arrow left"
            className="!block lg:py-5 lg:px-7 lg:rounded-bl-xl bg-black swiper-next lg:h-[82px] lg:w-[93.71px]"
          >
            <SvgArrowLeft className="rotate-180 text-white" />
          </button>
        </div>
      </div>
    </>
  )
}
